const strings = {
  en: {
    // Hero
    wordFlipWords: [
      'Standardize',
      'Smarten',
      'Transform',
      'Streamline',
      'Level-up',
      'Standardize',
    ],
    heroHeadlineSuffix: ' your sales process.',
    heroSubtitle:
      'Analyze, coach, and optimize your sales team with AI-powered insights \u2014 from recordings to real-time improvement, all in one unified system.',
    requestDemo: 'Request Free Demo',
    watchDemo: 'Watch Demo',

    // Video / Cultivate
    cultivateAccent: 'Cultivate',
    cultivateTitleSuffix: ' Winning Performance',
    cultivateSubtitle: 'Standardize winning strategies across your sales team',
    dashboardAlt: 'SAPOT AI Dashboard',

    // Features section
    mainFeaturesLabel: 'Main Features',
    featuresTitle: 'How sales teams perform better with Sapot AI',
    featuresSubtitle:
      'AI-powered insights, conversation analysis, and performance coaching \u2014 all in one platform. Track, improve, and scale your sales process with clarity and precision.',
    requestForFreeDemo: 'Request for free demo',

    // Products
    allFeaturesLabel: 'ALL FEATURES',
    allFeaturesTitle: 'One platform. Every tool you need.',
    getStartedForFree: 'Book Free Demo',
    allFeaturesImageAlt: 'SAPOT AI Features',

    // Final CTA
    ctaTitle: 'Ready to Transform Your Sales Team?',
    ctaSubtitle:
      'Join leading Malaysian enterprises using SAPOT AI to standardize sales performance and grow revenue.',
    ctaButton: 'Book Free Demo',
  },
  zh: {
    // Hero
    wordFlipWords: [
      '标准化',
      '智能化',
      '变革',
      '精简',
      '全面升级',
      '标准化',
    ],
    heroHeadlineSuffix: '您的销售流程。',
    heroSubtitle:
      '用 AI 驱动的洞察分析、辅导并优化您的销售团队——从录音复盘到实时提升,一站式搞定。',
    requestDemo: '申请免费演示',
    watchDemo: '观看演示',

    // Video / Cultivate
    cultivateAccent: '培育',
    cultivateTitleSuffix: '制胜业绩',
    cultivateSubtitle: '让制胜打法在整个销售团队中标准化落地',
    dashboardAlt: 'SAPOT AI 控制台',

    // Features section
    mainFeaturesLabel: '核心功能',
    featuresTitle: '销售团队如何借助 Sapot AI 实现业绩跃升',
    featuresSubtitle:
      'AI 洞察、对话分析、绩效辅导——全部集成于一个平台。以清晰与精准,追踪、优化并扩展您的销售流程。',
    requestForFreeDemo: '申请免费演示',

    // Products
    allFeaturesLabel: '全部功能',
    allFeaturesTitle: '一个平台,集齐所有工具',
    getStartedForFree: '预约免费演示',
    allFeaturesImageAlt: 'SAPOT AI 功能总览',

    // Final CTA
    ctaTitle: '准备好让您的销售团队焕然一新了吗?',
    ctaSubtitle: '众多马来西亚头部企业正在使用 SAPOT AI 实现销售标准化、驱动业绩增长,加入他们吧。',
    ctaButton: '预约免费演示',
  },
};

export default strings;
